module.exports = __webpack_public_path__ + "static/media/redes01.0473a244.svg";